import React, { useState } from 'react';
import './SubTabs.css';

function SubTabs() {
  const [selectedPrinciple, setSelectedPrinciple] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Add resize listener
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const roles = [
    {
      id: 'knowYourCustomer',
      label: 'Know your Customer',
      title: 'Know your Customer',
      description: 'To deliver maximum value, start by stepping into the customer’s shoes. Understand their needs, how they work and how they interact with our product. By knowing our customers deeply, we can create innovative, user-friendly solutions that truly make a difference. Be an advocate for the end user—listen, learn and share insights to ensure we always put their experience first.',
      image: 'img/Know-your-customer.svg',

    },
    {
      id: 'explorePrioritize',
      label: 'Explore and Prioritize',
      title: 'Explore and Prioritize',
      description: 'We believe that the best way to create value is to explore and prioritize the right things at the right time. We must understand the problem space and explore different solutions before we commit to building something.',
      image: 'img/Figur-8-Explore and prioritize-outline-RGB.svg',

    },
    {
      id: 'buildMeasureLearn',
      label: 'Build Measure Learn',
      title: 'Build Measure Learn',
      description: 'We follow a build-measure-learn feedback loop to ensure we\'re building the right things and learning from our experiences. This helps us make data-driven decisions and continuously improve our product.',
      image: 'img/Figur-13-Build-Measure-Learn-outline-RGB.svg',

    },
    {
      id: 'beCurious',
      label: 'Be Curious',
      title: 'Be Curious',
      description: 'Curiosity sparks innovation! Dive into new technologies, uncover customer needs and tackle challenges with fresh ideas and bold questions. By staying curious, we create smarter solutions, stronger connections and endless possibilities. Let’s explore, discover and shape the future together!',
      image: 'img/Figur-9-Continuous improvement-outline-RGB.svg',

    },
    {
      id: 'letsDoIt',
      label: 'Let\'s Do It',
      title: 'Let\'s Do It',
      description: 'If you see something that needs fixing, act fast—just do it. Whether it’s a quick tweak or a simple solution, small actions done with speed can create big wins for our customers. Trust your instincts and take charge. When we move quickly and focus on what matters, we make a real difference.',
      image: 'img/Empowerment.svg',

    },
    {
      id: 'creativeTogether',
      label: 'Creative Together',
      title: 'Creative Together',
      description: 'The best ideas happen when we join forces. “Creative Together” means sharing ideas, combining strengths and building something bigger than ourselves. By collaborating, we spark innovation and turn creativity into impact—together, we make it happen!',
      image: 'img/Creative-together.svg',

    }
  ];

  const handleRoleClick = (roleId) => {
    setSelectedPrinciple(roleId === selectedPrinciple ? null : roleId);
  };

  const handlePopupBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      setSelectedPrinciple(null);
    }
  };

  const handleGlobeClick = () => {
    setSelectedPrinciple(selectedPrinciple === 'centerGlobe' ? null : 'centerGlobe');
  };

  const renderMobilePrinciples = () => (
    <div className="mobile-principles-container">
      <div className="mobile-globe">
        <img src="img/Team-globe-core-principles.svg" alt="Team Globe" />
      </div>
      <div className="mobile-principles-grid">
        {roles.map(role => (
          <div
            key={role.id}
            className="mobile-principle-item"
            onClick={() => handleRoleClick(role.id)}
          >
            <img src={role.image} alt={role.title} />
            <h3>{role.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );

  const renderPrincipleGrid = () => (
    <div className="role-grid">
      {isMobile ? renderMobilePrinciples() : (
        <div className="principles-circle">
          <div
            className={`center-globe ${selectedPrinciple ? 'faded' : ''}`}
            onClick={handleGlobeClick}
          >
            <img src="img/Team-globe-core-principles.svg" alt="Team Globe" />
          </div>
          {roles.map(role => (
            <div key={role.id} className={`principle-item principle-${role.id}`}>
              <div
                className={`role-container ${selectedPrinciple && selectedPrinciple !== role.id ? 'faded' : ''}`}
                onClick={() => handleRoleClick(role.id)}
              >
                <img className={`${role.id}-show playbook-role`} src={role.image} alt={role.alt} />
                <h3 className="role-title">{role.title}</h3>
              </div>
            </div>
          ))}
        </div>
      )}
      {selectedPrinciple && (
        <div className="principle-popup" onClick={handlePopupBackgroundClick}>
          <div className="principle-popup-content" onClick={e => e.stopPropagation()}>
            <span
              className="close-button"
              onClick={() => setSelectedPrinciple(null)}
              role="button"
              tabIndex="0"
              aria-label="Close popup"
            >
              &times;
            </span>
            <div className="popup-text-content">
              <h2>{selectedPrinciple === 'centerGlobe' ? 'Customer Value' : roles.find(r => r.id === selectedPrinciple).title}</h2>
              <p>{selectedPrinciple === 'centerGlobe' ? 'Everything we do starts and ends with the customer. “Customer Value” is our guiding star—delivering solutions that truly matter, solve real problems, and make life easier for those we serve. When we focus on creating value, we create impact. For the customer, for the team, for everyone.' : roles.find(r => r.id === selectedPrinciple).description}</p>
            </div>
            <div className="popup-image-content">
              <img
                src={selectedPrinciple === 'centerGlobe' ? 'img/Team-globe-core-principles.svg' : roles.find(r => r.id === selectedPrinciple).image}
                alt={selectedPrinciple === 'centerGlobe' ? 'Customer Value' : roles.find(r => r.id === selectedPrinciple).title}
                className="popup-corner-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div id="team-description" className="fh5co-features-outer">
      {renderPrincipleGrid()}
    </div>
  );
}

export default SubTabs;

